import { Box, Typography } from '@mui/material'
import { COLORS } from '~theme/colors'

export function StepPagination({
  active,
  pages,
}: {
  active: string
  pages: string[]
}) {
  return (
    <Box sx={{ display: 'flex', gap: 2 }}>
      {pages.map((page) => (
        <Typography
          data-testid="pagination"
          key={page}
          variant="label"
          sx={{
            color:
              active === page ? COLORS.primary.white : COLORS.greys.ultraLight,
            backgroundColor:
              active === page ? COLORS.secondary.darkBlue : COLORS.greys.dark,
            borderRadius: 50,
            width: '24px',
            height: '24px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          {page}
        </Typography>
      ))}
    </Box>
  )
}
